import * as NotificationActions from "../actions/notification.actions";
import { createReducer, on } from "@ngrx/store";

export interface INotificationState {
  show: boolean;
}

const initialState: INotificationState = {
  show: false,
};

export const reducer = createReducer(
  initialState,
  on(NotificationActions.snackbarOpen, (state) => ({
    ...state,
    show: true,
  })),
  on(NotificationActions.snackbarClose, (state) => ({
    ...state,
    show: false,
  })),
);
